function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "messages_announcements_svg__b",
  d: "M0 .065h61.404v56.11H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "messages_announcements_svg__d",
  d: "M0 .065h61.404v12.704H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "messages_announcements_svg__f",
  d: "M.097.044h5.687v2.648H.097z"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-32.3%",
  y: "-32.3%",
  width: "164.5%",
  height: "164.5%",
  filterUnits: "objectBoundingBox",
  id: "messages_announcements_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#D4D4D4",
  filter: "url(#messages_announcements_svg__a)",
  cx: 83.5,
  cy: 94.5,
  r: 46.5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  x: 23,
  y: 21,
  width: 120,
  height: 120,
  rx: 60
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(49 55.055)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "messages_announcements_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#messages_announcements_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.939 56.175h41.289A3.176 3.176 0 0061.404 53V3.241A3.176 3.176 0 0058.228.065H3.176A3.176 3.176 0 000 3.241V53a3.176 3.176 0 003.176 3.176H16.94z",
  fill: "#FFF",
  mask: "url(#messages_announcements_svg__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(49 55.055)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "messages_announcements_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#messages_announcements_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M61.404 3.241v9.528H0V3.241A3.176 3.176 0 013.176.065h55.052a3.176 3.176 0 013.176 3.176",
  fill: "#0086D8",
  mask: "url(#messages_announcements_svg__e)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M55.352 59.355a2.117 2.117 0 110 4.234 2.117 2.117 0 010-4.234",
  fill: "#DA4D7A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.822 59.355a2.117 2.117 0 110 4.234 2.117 2.117 0 010-4.234",
  fill: "#F9BA48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.291 59.355a2.117 2.117 0 110 4.234 2.117 2.117 0 010-4.234",
  fill: "#44C94E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.465 59.355h10.587a2.117 2.117 0 110 4.234H93.465a2.117 2.117 0 110-4.234",
  fill: "#285680"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.256 109.734l-4.71.911a.96.96 0 00-.76 1.124l1.093 5.652c.101.52.604.86 1.125.76l4.71-.91a1.921 1.921 0 001.52-2.249l-.73-3.768a1.921 1.921 0 00-2.248-1.52",
  fill: "#344A5D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.472 109.672l2.368 12.246c.1.52.604.86 1.124.76l3.768-.73a.96.96 0 00.774-.857l.433-13.117-8.467 1.698z",
  fill: "#B33D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.228 98.186l-4.71.91a2.882 2.882 0 00-2.28 3.373l1.094 5.652a2.882 2.882 0 003.372 2.28l4.71-.911a.96.96 0 00.76-1.124l-1.822-9.42a.96.96 0 00-1.124-.76",
  fill: "#344A5D"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DA4D7A",
  d: "M62.286 98.368l9.42-1.821 2.186 11.303-9.42 1.822z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.785 105.295l.547 2.826a2.881 2.881 0 003.372 2.28l4.71-.911-.546-2.826-4.71.91a2.882 2.882 0 01-3.373-2.279",
  fill: "#243341"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B33D62",
  d: "M63.926 106.846l9.42-1.822.546 2.826-9.42 1.822z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.361 88.074c-4.155.803-6.882 4.837-6.079 8.993.804 4.155 4.838 6.882 8.994 6.079 4.155-.804 6.882-4.838 6.078-8.994-.803-4.155-4.837-6.882-8.993-6.078",
  fill: "#F9BA48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.73 100.32c-3.673.71-7.25-1.338-8.586-4.692.001.475.045.956.138 1.439.804 4.155 4.838 6.882 8.994 6.078 4.155-.803 6.882-4.837 6.078-8.993a7.652 7.652 0 00-.408-1.387c.01 3.61-2.544 6.844-6.217 7.555",
  fill: "#CE952F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.555 80.56a.96.96 0 00-.91.102L70.78 96.81l2.159 11.164 26.928 4.565a.96.96 0 001.098-1.129l-5.829-30.144a.96.96 0 00-.581-.707",
  fill: "#F9BA48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.164 109.435a.959.959 0 01-.844.278l-26.928-4.565.547 2.826 26.928 4.565a.96.96 0 001.098-1.129l-.547-2.826a.96.96 0 01-.254.851",
  fill: "#CE952F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.117 76.588l-5.652 1.093a.96.96 0 00-.76 1.124l6.922 35.795c.101.52.604.86 1.125.76l5.652-1.093a.96.96 0 00.76-1.124l-6.923-35.795a.96.96 0 00-1.124-.76",
  fill: "#DA4D7A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.857 111.441l-5.652 1.093a.96.96 0 01-1.124-.76l.546 2.826c.101.52.604.86 1.125.76l5.652-1.093a.96.96 0 00.76-1.124l-.547-2.826a.96.96 0 01-.76 1.124",
  fill: "#B33D62"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(111.123 91.873)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "messages_announcements_svg__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#messages_announcements_svg__f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.007 1.946l-3.768.729A.96.96 0 01.875.79L4.643.062a.96.96 0 01.364 1.884",
  fill: "#DBD9D1",
  mask: "url(#messages_announcements_svg__g)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M107.101 86.582c-.824.16-1.445-.787-.977-1.479l2.15-3.18a.96.96 0 011.59 1.075l-2.15 3.18a.956.956 0 01-.613.404M113.63 106.05a.956.956 0 01-.72-.147l-3.18-2.15a.96.96 0 011.075-1.59l3.18 2.15c.692.468.468 1.577-.355 1.737",
  fill: "#DBD9D1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M155.486 93c.65 0 1.176.526 1.176 1.176v3.134h3.135c.606 0 1.105.46 1.17 1.048l.006.128c0 .65-.526 1.176-1.176 1.176h-3.135v3.135c0 .606-.458 1.105-1.047 1.17l-.129.006c-.649 0-1.175-.526-1.175-1.176l-.001-3.135h-3.134a1.176 1.176 0 01-1.17-1.047l-.006-.129c0-.649.526-1.175 1.176-1.175l3.134-.001v-3.134c0-.606.46-1.105 1.048-1.17z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.486 0c.886 0 1.605.718 1.605 1.604l-.001 4.278h4.279c.837 0 1.524.64 1.597 1.458l.007.146c0 .886-.718 1.605-1.604 1.605L71.09 9.09v4.279c0 .837-.64 1.524-1.457 1.597l-.147.007a1.604 1.604 0 01-1.604-1.604V9.09h-4.278c-.837 0-1.524-.64-1.597-1.457L62 7.486c0-.886.718-1.604 1.604-1.604h4.278V1.604c0-.837.64-1.524 1.458-1.597z",
  fill: "#44C94E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  cx: 2.5,
  cy: 54.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#913FA3",
  cx: 135.5,
  cy: 137.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#0086D8",
  strokeWidth: 2,
  cx: 8.5,
  cy: 131.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#E57339",
  strokeWidth: 2,
  cx: 146.5,
  cy: 21.5,
  r: 3.5
})));

function SvgMessagesAnnouncements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 171,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/messages_announcements.5f08e67f.svg";
export { SvgMessagesAnnouncements as ReactComponent };